import { ProgressStatusHandle, ProgressStatusProps } from './Types';
import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from './ProgressStatus.module.scss'
import { useProgress } from 'hooks/useProgress'
import { forwardRef, PropsWithChildren, useImperativeHandle } from 'react'
import cx from 'classnames'

export const ProgressStatus = forwardRef<ProgressStatusHandle, PropsWithChildren<ProgressStatusProps>>(({ children, ...options }, fRef) => {
  const progress = useProgress(options)
  const { start, progress: progressComplete, isRunning } = progress

  useImperativeHandle(fRef, () => ({
    start
  }))

  return (
    <li
      className={cx(Styles.progressHeading, {
        [Styles.running]: isRunning || progressComplete >= 99,
        [Styles.completed]: !isRunning && progressComplete === 100,
      })}
    >
      <Heading level={5}>
        {children}
        {isRunning && (
          <>
            <span>... </span>
            <span className={Styles.progressPercentage}>{progressComplete}%</span>
          </>
        )}
      </Heading>
    </li>
  )
})
